export interface Testimonial {
  name: string
  role: string
  text: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Micaela R.',
    role: 'Profe de Barre hace 2 años',
    text: 'Antes pasaba mis domingos enteros armando clases. Ahora con este sistema armo la semana en 30 minutos. Mis alumnas notaron el cambio de energía porque yo estoy más relajada.',
  },
  {
    name: 'Julieta G.',
    role: 'Instructora de Pilates y Barre',
    text: 'Me salvó la vida. Siempre sentía que repetía los mismos 5 ejercicios de glúteos. La biblioteca de variaciones es oro puro, mis clases ahora son súper dinámicas.',
  },
  {
    name: 'Carolina M.',
    role: 'Profe principiante',
    text: 'Recién arranco a dar clases y me daba pánico quedarme en blanco. Tener la estructura clara del Tomo 1 me dio muchísima seguridad para pararme frente al grupo.',
  },
  {
    name: 'Luciana V.',
    role: 'Dueña de estudio',
    text: 'Compré el material para unificar el criterio de las profes de mi estudio. Es excelente. Nos organizó a todas y la calidad de las clases subió un 100%.',
  },
  {
    name: 'Paula S.',
    role: 'Profe de Barre',
    text: 'Lo que más me costaba era adaptar los ejercicios para las chicas nuevas sin frenar la clase. El módulo de adaptaciones me dio las herramientas exactas que necesitaba.',
  },
]
